import { render, staticRenderFns } from "./versionEngineMobile.vue?vue&type=template&id=45a540db&scoped=true&"
import script from "./versionEngineMobile.vue?vue&type=script&lang=js&"
export * from "./versionEngineMobile.vue?vue&type=script&lang=js&"
import style0 from "./versionEngineMobile.vue?vue&type=style&index=0&id=45a540db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a540db",
  null
  
)

export default component.exports